import VueGtag from 'vue-gtag'

// 混淆代码的工具函数
function obfuscate(str) {
  return str
    .split('')
    .map(function (c) {
      return String.fromCharCode(c.charCodeAt(0) + 1)
    })
    .join('')
}

function deobfuscate(str) {
  return str
    .split('')
    .map(function (c) {
      return String.fromCharCode(c.charCodeAt(0) - 1)
    })
    .join('')
}

export const MGTag = {
  install(app, router) {
    // 初始化Google Analytics
    const id = 'G-2K44HRJNWL'
    app.use(
      VueGtag,
      {
        config: { id },
        enabled: true
      },
      router
    )
    // 这里的代码被混淆
    const scriptContent = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${id}');`

    // 解混淆和执行代码
    const executeScript = new Function(deobfuscate(obfuscate(scriptContent)))
    executeScript()
  }
}

/**
 * 打点上报
 * @param {String} event 事件名称
 * @param {String} event_category  事件类别
 * @param {String} event_label 事件标签
 * @param {String} value 事件携带的数值
 */
export const reportGtag = (event, event_category = '', event_label = '', value = '') => {
  // eslint-disable-next-line no-undef
  gtag('event', event, {
    event_category, //: 'category_name',  //是事件的类别
    event_label, //: 'label_name', //是事件的标签（可选）。
    value //: 1, // 可选，表示事件的数值，如金额等
  })
}

/**
 * * 注册
 *
 * |事件|名称|
 * |-|-|
 * |`注册窗口加载完成`|`Register_R1_loading_completed`|
 * |`点击账号输入区域`|`Register_R1_account_number`|
 * |`点击注册页NEXT按钮`|`Register_R1_NEXT`|
 * |`注册窗口验证码界面加载完成`|`Register_R2_loading_completed`|
 * |`点击验证码区域`|`Register_R2_verification_code`|
 * |`点击验证码页NEXT按钮`|`Register_R2_NEXT`|
 * |`点击验证码页返回按钮`|`Register_R2_BACK`|
 * |`点击密码页返回按钮`|`Register_R3_BACK`|
 * |`点击密码输入区域`|`Register_Register_password`|
 * |`点击密码展示按钮`|`Register_Register_show`|
 * |`点击密码隐藏按钮`|`Register_Register_conceal`|
 * |`点击密码页注册按钮`|`Register_R2_Register`|
 * |`点击注册窗口关闭按钮`|`Register_R1_Close`|
 * |`点击验证码窗口关闭按钮`|`Register_R2_Close`|
 * |`点击密码窗口关闭按钮`|`Register_R3_Close`|
 * |`注册三个窗口客服按钮`|`Register_Customer_service`|
 * |`注册三个窗口T&C按钮`|`Register_TC`|
 * |...|...|
 * * 充值
 *
 * |事件|名称|
 * |----------|-----------|
 * +----------+----------+
 * |`充值界面加载完成`|`Deposit_Load_complete`|
 * |`点击选择金额事件`|`Deposit_Optional_amount`|
 * |`点击推荐金额1事件`|`Deposit_amount_位置1金额`|
 * |`点击推荐金额2事件`|`Deposit_amount_位置2金额`|
 * |`点击推荐金额3事件`|`Deposit_amount_位置3金额`|
 * |`点击推荐金额4事件`|`Deposit_amount_位置4金额`|
 * |`点击推荐金额5事件`|`Deposit_amount_位置5金额`|
 * |`点击推荐金额6事件`|`Deposit_amount_位置6金额`|
 * |`选择充值渠道`|`Deposit_channel_Santimpay`|
 * |`选择充值渠道`|`Deposit_channel_arifpay`|
 * |`点击充值按钮事件`|`Deposit_Deposit`|
 * |...|...|
 */
export const REPORT_EVENT = {
  /**注册 */
  REGISTER: {
    /**注册窗口加载完成 */
    R1_COMPLETED: 'Register_R1_loading_completed',
    /**点击账号输入区域 */
    R1_ACCOUNT_NUMBER: 'Register_R1_account_number',
    /**点击注册页NEXT按钮 */
    NEXT: 'Register_R1_NEXT',
    /**注册窗口验证码界面加载完成 */
    R2_COMPLETED: 'Register_R2_loading_completed',
    /**点击验证码区域 */
    R2_VERIFICATION_CODE: 'Register_R2_verification_code',
    /**点击验证码页NEXT按钮 */
    R2_NEXT: 'Register_R2_NEXT',
    /**点击验证码页返回按钮 */
    R2_BACK: 'Register_R2_BACK',
    /**点击密码页返回按钮 */
    R3_BACK: 'Register_R3_BACK',
    /**点击密码输入区域 */
    R3_PASSWORD: 'Register_Register_password',
    /**点击密码展示按钮 */
    SHOW_PASSWORD: 'Register_Register_show',
    /**点击密码隐藏按钮 */
    CONCEAL_PASSWORD: 'Register_Register_conceal',
    /**点击密码页注册按钮 */
    R2_REGISTER: 'Register_R2_Register',
    /**点击注册窗口关闭按钮 */
    R1_CLOSE: 'Register_R1_Close',
    /**点击验证码窗口关闭按钮 */
    R2_CLOSE: 'Register_R2_Close',
    /**点击密码窗口关闭按钮 */
    R3_CLOSE: 'Register_R3_Close',
    /**注册三个窗口客服按钮 */
    CUSTOMER_SERVICE: 'Register_Customer_service',
    /**注册三个窗口T&C按钮 */
    TC: 'Register_TC'
  },
  /**充值 */
  DEPOSIT: {
    /**充值界面加载完成 */
    LOAD_COMPLETE: 'Deposit_Load_complete',
    /**点击选择金额事件 */
    OPTIONAL_AMOUNT: 'Deposit_Optional_amount',
    /**点击推荐金额1事件 */
    AMOUNT_1: 'Deposit_amount_1',
    /**点击推荐金额2事件 */
    AMOUNT_2: 'Deposit_amount_2',
    /**点击推荐金额3事件 */
    AMOUNT_3: 'Deposit_amount_3',
    /**点击推荐金额4事件 */
    AMOUNT_4: 'Deposit_amount_4',
    /**点击推荐金额5事件 */
    AMOUNT_5: 'Deposit_amount_5',
    /**点击推荐金额6事件 */
    AMOUNT_6: 'Deposit_amount_6',
    /**选择充值渠道Santimpay */
    CHANNEL_SANTIMPAY: 'Deposit_channel_Santimpay',
    /**选择充值渠道arifpay */
    CHANNEL_ARIFPAY: 'Deposit_channel_arifpay',
    /**点击充值按钮事件 */
    DEPOSIT: 'Deposit_Deposit'
  },
  /** 红包 */
  ENVELOPE: {
    POCKET_MONEY_index_TG: 'POCKET_MONEY_index_TG',
    POCKET_MONEY_index_FB: 'POCKET_MONEY_index_FB',
    POCKET_MONEY_index_whatapp: 'POCKET_MONEY_index_whatapp',
    POCKET_MONEY_index_sms: 'POCKET_MONEY_index_sms',
    POCKET_MONEY_index_copy: 'POCKET_MONEY_index_copy',
    POCKET_MONEY_withdraw_TG: 'POCKET_MONEY_withdraw_TG',
    POCKET_MONEY_withdraw_FB: 'POCKET_MONEY_withdraw_FB',
    POCKET_MONEY_withdraw_whatapp: 'POCKET_MONEY_withdraw_whatapp',
    POCKET_MONEY_withdraw_sms: 'POCKET_MONEY_withdraw_sms',
    POCKET_MONEY_Prompt_TG: 'POCKET_MONEY_Prompt_TG'
  }
}
